import React, { Component } from 'react'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'

import {
  InputField,
  CheckboxField,
  SelectField,
  RadiobuttonGroup,
} from '../../../components/inputs'
import LoaderButton from '../../../components/loaderButton'
import { ReduxFormProps } from '../../../forms'
import dateHelpers from '../../../helpers/dateHelpers'
import { allStateOptions } from '../../common/stateOptions'
import { connect } from 'react-redux'
import { Callback } from '../../../utils/types'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')

const dollarAmountMask = createNumberMask({
  allowDecimal: true,
  integerLimit: 9,
})

const dateMask = [
  /[0-1]/,
  /0?[1-9]|1?[0-2]/,
  '/',
  /[0-3]/,
  /3?[0-1]|[0-9]/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
export interface Props {
  generateEmail: boolean
  showCoApplicantForm: boolean
  toggleShowCoApplicantForm: Callback
}
export interface FormProps {
  birthdate: string
  ssn: string
  startDate: string
  monthlyHousingExpense: string
  employmentStartDate: string
  statedAnnualIncome: string
  confirmDisclosure: string
  coappFirstName?: string
  coappLastName?: string
  coappLine1?: string
  coappLine2?: string
  coappCity?: string
  coappState?: string
  coappZip?: string
  coappPhone?: string
  coappBirthdate?: string
  coappSsn?: string
  coappStartDate?: string
  coappMonthlyHousingExpense?: string
  coappEmploymentStartDate?: string
  coappStatedAnnualIncome?: string
  coappConfirmDisclosure?: string
  coappEmail?: string
  coappEmail2?: string
}

const FORM_NAME = 'SoftPullForm'
export class SoftPullForm extends Component<ReduxFormProps<Props, FormProps>> {
  formatAndConcat = (s1: string, s2: string) => {
    if (s1 !== null && s1 !== undefined && s1.trim() !== '') {
      return s1 + s2.charAt(0).toUpperCase() + s2.slice(1)
    }
    return s2
  }

  renderPersonalInformation = (prefix: string) => {
    return (
      <div className="form__grid">
        <Field
          type="text"
          label="Date of birth"
          name={this.formatAndConcat(prefix, 'birthdate')}
          component={InputField}
          placeholder="MM/DD/YYYY"
          mask={dateMask}
        />
        <Field
          type="text"
          label="Social Security Number"
          name={this.formatAndConcat(prefix, 'ssn')}
          component={InputField}
          placeholder="XXX-XX-XXXX"
          mask={[
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ]}
        />
        <Field
          type="text"
          label="Move in date"
          name={this.formatAndConcat(prefix, 'startDate')}
          component={InputField}
          placeholder="MM/DD/YYYY"
          mask={dateMask}
          pipe={autoCorrectedDatePipe}
          keepCharPositions={true}
        />
        <Field
          type="text"
          label="Monthly mortgage / rent"
          name={this.formatAndConcat(prefix, 'monthlyHousingExpense')}
          component={InputField}
          mask={dollarAmountMask}
        />
        <Field
          type="text"
          label="Employment start date"
          name={this.formatAndConcat(prefix, 'employmentStartDate')}
          component={InputField}
          placeholder="MM/DD/YYYY"
          mask={dateMask}
        />
        <Field
          type="text"
          label="Annual gross income"
          name={this.formatAndConcat(prefix, 'statedAnnualIncome')}
          component={InputField}
          mask={dollarAmountMask}
        />
      </div>
    )
  }

  render() {
    const {
      generateEmail,
      showCoApplicantForm,
      toggleShowCoApplicantForm,
      handleSubmit,
      submitting,
    } = this.props

    return (
      <form className="form" name="SoftPullForm" onSubmit={handleSubmit}>
        <div className="form__paragraph" style={{ textAlign: 'justify' }}>
          <strong>Please Read Disclosures to Applicant: </strong>
          <em>
            Before we continue, I am required to cover some regulatory
            disclosures with you: <br />
            You need to authorize Flagship Credit Acceptance and any lender to
            whom Flagship Credit Acceptance forwards this application in
            connection with this application for the purpose of making
            pre-qualified offers of credit to access your credit report and for
            no other purpose. Please confirm your authorization to allow
            Flagship Credit Acceptance and any such lender to obtain your credit
            report solely in connection with this application for the purpose of
            making pre-qualified offers of credit by pressing the # key now
          </em>
          <br />
          <br />
          <strong>ECOA Disclosure: </strong>
          <em>
            Alimony, child support, or separate maintenance income need not be
            revealed if you do not wish to have it considered as a basis for
            repaying this obligation.
          </em>
        </div>

        {this.renderPersonalInformation('')}

        {showCoApplicantForm && (
          <div>
            <div className="form__title">Co-Applicant Personal Details</div>
            <div className="form__grid">
              <Field<any>
                type="text"
                label="Legal first name"
                name="coappFirstName"
                component={InputField}
                aria-required="true"
              />

              <Field<any>
                type="text"
                label="Legal last name"
                name="coappLastName"
                component={InputField}
                aria-required="true"
              />

              <Field<any>
                type="text"
                label="Address"
                name="coappLine1"
                component={InputField}
                aria-required="true"
              />

              <Field
                type="text"
                label="Address line 2"
                name="coappLine2"
                component={InputField}
              />

              <Field<any>
                type="text"
                label="City"
                name="coappCity"
                component={InputField}
                aria-required="true"
              />

              <div className="form__grid">
                <Field<any>
                  label="State"
                  name="coappState"
                  component={SelectField}
                  aria-required="true"
                >
                  {allStateOptions}
                </Field>

                <Field<any>
                  type="text"
                  label="Zip code"
                  name="coappZip"
                  component={InputField}
                  mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                  aria-required="true"
                />
              </div>

              <Field<any>
                type="text"
                label="Phone number"
                name="coappPhone"
                component={InputField}
                placeholder="(___)___-____"
                mask={[
                  '(',
                  /[1-9]/,
                  /\d/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                aria-required="true"
              />
            </div>
            <div>
              <div className="form__email-btns-wrapper">
                <RadiobuttonGroup
                  name="generateEmail"
                  value={false}
                  label="Use customer email"
                  checked={!generateEmail}
                  checkmarkIcon
                />

                <RadiobuttonGroup
                  name="generateEmail"
                  value={true}
                  label="No email given"
                  checked={generateEmail}
                  checkmarkIcon
                />
              </div>

              {!generateEmail && (
                <div className="form__grid">
                  <Field<any> // TODO-TS
                    type="text"
                    label="Email"
                    name="coappEmail"
                    component={InputField}
                    aria-required="true"
                  />

                  <Field<any> // TODO-TS
                    type="text"
                    label="Re-enter email"
                    name="coappEmail2"
                    component={InputField}
                    aria-required="true"
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {showCoApplicantForm && this.renderPersonalInformation('coapp')}

        <Field
          type="checkbox"
          name="confirmDisclosure"
          label="Confirm you have read the above disclosure"
          component={CheckboxField}
        />
        <div className="form__group refi-app__form-buttons">
          <button
            type="button"
            className="button button-drive-america"
            onClick={toggleShowCoApplicantForm}
          >
            {showCoApplicantForm
              ? 'Remove Co-applicant'
              : 'Apply with Co-applicant'}
          </button>
          <LoaderButton
            type="submit"
            className="button button-drive-america"
            isLoading={submitting}
            disabled={this.props.invalid && this.props.submitFailed}
          >
            Submit
          </LoaderButton>
        </div>
      </form>
    )
  }
}

export const validate = (data, props) => {
  const {
    birthdate,
    ssn,
    startDate,
    monthlyHousingExpense,
    employmentStartDate,
    statedAnnualIncome,
    confirmDisclosure,
    coappFirstName,
    coappLastName,
    coappLine1,
    coappCity,
    coappState,
    coappZip,
    coappPhone,
    coappBirthdate,
    coappSsn,
    coappStartDate,
    coappMonthlyHousingExpense,
    coappEmploymentStartDate,
    coappStatedAnnualIncome,
    coappConfirmDisclosure,
    coappEmail,
    coappEmail2,
    generateEmail,
  } = data

  const { showCoApplicantForm } = props
  const errors: Partial<FormProps> = {}

  if (!birthdate) {
    errors.birthdate = 'Date of birth is required.'
  } else if (birthdate.match('_')) {
    errors.birthdate = 'Date of birth looks incomplete.'
  } else if (!dateHelpers.calculateAge(birthdate)) {
    errors.birthdate = 'Date of birth is not valid.'
  }

  if (!ssn) {
    errors.ssn = 'Social Security Number is required.'
  } else if (ssn.match('_')) {
    errors.ssn = 'Social Security Number looks incomplete.'
  }

  if (!startDate) {
    errors.startDate = 'Move in date is required.'
  }

  if (!monthlyHousingExpense) {
    errors.monthlyHousingExpense = 'Monthly mortgage is required.'
  }

  if (!employmentStartDate) {
    errors.employmentStartDate = 'Employment start date is required.'
  }

  if (!statedAnnualIncome) {
    errors.statedAnnualIncome = 'Annual income is required.'
  }

  if (!confirmDisclosure) {
    errors.confirmDisclosure = 'Please confirm you have read the disclosure.'
  }

  if (showCoApplicantForm) {
    if (!coappFirstName) {
      errors.coappFirstName = 'First name is required.'
    }

    if (!coappLastName) {
      errors.coappLastName = 'Last name is required.'
    }

    if (!coappLine1) {
      errors.coappLine1 = 'Address is required.'
    }

    if (!coappCity) {
      errors.coappCity = 'City is required.'
    }

    if (!coappState) {
      errors.coappState = 'State is required.'
    }

    if (!coappZip) {
      errors.coappZip = 'Zip code is required.'
    }

    if (!coappPhone) {
      errors.coappPhone = 'Phone number is required.'
    }

    if (!coappBirthdate) {
      errors.coappBirthdate = 'Date of birth is required.'
    } else if (coappBirthdate.match('_')) {
      errors.coappBirthdate = 'Date of birth looks incomplete.'
    } else if (!dateHelpers.calculateAge(coappBirthdate)) {
      errors.coappBirthdate = 'Date of birth is not valid.'
    }

    if (!coappSsn) {
      errors.coappSsn = 'Social Security Number is required.'
    } else if (coappSsn.match('_')) {
      errors.coappSsn = 'Social Security Number looks incomplete.'
    }

    if (!coappStartDate) {
      errors.coappStartDate = 'Move in date is required.'
    }

    if (!coappMonthlyHousingExpense) {
      errors.coappMonthlyHousingExpense = 'Monthly mortgage is required.'
    }

    if (!coappEmploymentStartDate) {
      errors.coappEmploymentStartDate = 'Employment start date is required.'
    }

    if (!coappStatedAnnualIncome) {
      errors.coappStatedAnnualIncome = 'Annual income is required.'
    }

    if (!coappConfirmDisclosure) {
      errors.coappConfirmDisclosure =
        'Please confirm you have read the disclosure.'
    }

    if (!generateEmail) {
      if (!coappEmail) {
        errors.coappEmail = 'Email is required'
      }

      if (coappEmail && coappEmail !== coappEmail2) {
        errors.coappEmail2 = 'Does not match'
      }
    }
  }

  return errors
}

const BaseSoftPullForm = reduxForm<FormProps, Props>({
  form: FORM_NAME,
  validate,
  enableReinitialize: false,
  destroyOnUnmount: true,
})(SoftPullForm)

export default connect((state) => {
  const selector = formValueSelector(FORM_NAME)
  const generateEmail = selector(state, 'generateEmail') === true
  return { generateEmail }
})(BaseSoftPullForm)
